import { createBrowserRouter } from "react-router";
import { HomePage } from "./pages/HomePage";
import { ContentPage } from "./pages/ContentPage";
import { contentPages } from "./data/contentPages";
import { persianPages } from "./data/fa";
import { FaHomePage } from "./pages/FaHomePage";
import { FaContentPage } from "./pages/FaContentPage";
import { FaSupplierJoinPage } from "./pages/FaSupplierJoinPage";

export const router = createBrowserRouter([
  { path: "/", Component: HomePage },
  { path: "/fa", Component: FaHomePage },
  { path: "/fa/", Component: FaHomePage },
  ...persianPages.map((page) => ({ path: page.path, element: <FaContentPage page={page} /> })),
  { path: "/fa/suppliers/join", Component: FaSupplierJoinPage },
  ...contentPages.map((page) => ({ path: page.path, element: <ContentPage page={page} /> })),
  {
    path: "/products",
    lazy: async () => {
      const { ProductsPage } = await import("./pages/ProductsPage");
      return { Component: ProductsPage };
    },
  },
  {
    path: "/products/:slug",
    lazy: async () => {
      const { ProductDetailPage } = await import("./pages/ProductDetailPage");
      return { Component: ProductDetailPage };
    },
  },
]);
